import { TTotalAppVolumeResponse } from 'views/types/volume';
import { $api } from './interceptor';
import { volumeStore } from 'views/store/useVolumeStore';

const VolumeService = () => {
  const getTotalAppValue = async () => {
    try {
      const { data } = await $api.get<TTotalAppVolumeResponse>(`api/admins/app-total-volume`);

      volumeStore.setState({ appVolumes: data });
    } catch (error) {
      console.error('Error fetching total app volume:', error);
    }
  };

  const getUserAppVolume = async (userId: string | number) => {
    try {
      const { data } = await $api.get<TTotalAppVolumeResponse>(
        `api/admins/user-total-volume?id=${userId}`,
      );

      return data;
    } catch (error) {
      console.error('Error fetching user app volume:', error);
    }
  };

  return { getTotalAppValue, getUserAppVolume };
};

export const volumeService = VolumeService();
